// import { create } from "zustand";
// import { persist } from "zustand/middleware";

// const useFilterStore = create(
//     persist(
//         (set, get) => ({
//             filters: {},

//             setFilters: (page, filters) =>
//                 set((state) => ({
//                     filters: { 
//                         ...state.filters, 
//                         [page]: filters 
//                     },
//                 })),

//             getFilters: (page) => get().filters[page] || null,

//             clearFilters: (page) => 
//                 set((state) => {
//                     const updatedFilters = { ...state.filters };
//                     delete updatedFilters[page];
//                     return { filters: updatedFilters };
//                 }),

//             // 🔹 Add this method to clear all filters
//             clearAllFilters: () => set({ filters: {} }),
//         }),
//         {
//             name: "filter-storage",
//             getStorage: () => localStorage,
//             partialize: (state) => ({ filters: state.filters }), // Store only filters
//         }
//     )
// );

// export default useFilterStore;


import { create } from "zustand";
import { persist } from "zustand/middleware";

const useFilterStore = create(
    persist(
        (set, get) => ({
            filters: {},
            isHydrated: false, // Track hydration status

            setFilters: (page, filters) => {
                set((state) => ({
                    filters: { 
                        ...state.filters, 
                        [page]: filters 
                    },
                }));
            },

            getFilters: (page) => {
                return get().filters[page] || null;
            },

            clearFilters: (page) => {
                set((state) => {
                    const updatedFilters = { ...state.filters };
                    delete updatedFilters[page];
                    return { filters: updatedFilters };
                });
            },

            clearAllFilters: () => {
                set({ filters: {} });
            },

            setHydrated: () => set({ isHydrated: true }), // Mark hydration complete
        }),
        {
            name: "filter-storage",
            getStorage: () => (typeof window !== "undefined" ? localStorage : undefined),
            partialize: (state) => ({ filters: state.filters }), 
            onRehydrateStorage: () => () => {
                useFilterStore.getState().setHydrated();
            },
        }
    )
);

export default useFilterStore;
